import Joi from "joi";

export const approvalPersonSchema = Joi.object({
  userId: Joi.string().min(2).label("User"),
  minValue: Joi.number().min(0.01).label("Min value"),
  maxValue: Joi.number()
    .min(0.01)
    .label("Max value")
    .when("minValue", {
      is: Joi.exist(),
      then: Joi.number()
        .min(Joi.ref("minValue"))
        .label("Max value must be greater than or equal to Min value"),
    }),
  order: Joi.number().min(1).label("Order"),
  purchaseOrderTypeId: Joi.string().min(2).label("Purchase order type"),
});
